export const REGIONS = {
    "grupo1":[
         {
            id: "g1_region1",
            secondId: "gr2-region-1",
            name: "Región 1: Andina Centroriental",
            color: {
                bg: "#7AD8E2",
                text: "#fff",
            },
        },
        {
             id: "g1_region2",
            secondId: "gr2-region-2",
            name: "Región 2: Andina Occidental",
            color: {
                bg: "#4AC1DD",
                text: "#fff",
            },
        },
        {
            id: "g1_region3",
            secondId: "gr2-region-3",
            name: "Región 3: Caribe Norte",
            color: {
                bg: "#13A8BA",
                text: "#fff",
            },
        },
        {
            id: "g1_region4",
            secondId: "gr2-region-4",
            name: "Región 4: Caribe Sur",
            color: {
                bg: "#23868E",
                text: "#fff",
            },
        },
        {
            id: "g1_region5",
            secondId: "gr2-region-5",
            name: "Región 5: Oriente",
            color: {
                bg: "#2288BC",
                text: "#fff",
            },
        },
        {
            id: "g1_region6",
            secondId: "gr2-region-6",
            name: "Región 6: Pacífico",
            color: {
                bg: "#126087",
                text: "#fff",
            },
        },
        {
            id: "g1_region7",
            secondId: "gr2-region-7",
            name: "Región 7: Sur",
            color: {
                bg: "#134863",
                text: "#fff",
            },
        },
    ],
    "grupo2":[
         {
            id: "g2_region1",
            secondId: "gr2-region-1",
            name: "Región 1: Andina Centroriental",
            color: {
                bg: "#7AD8E2",
                text: "#fff",
            },
        },
        {
             id: "g2_region2",
            secondId: "gr2-region-2",
            name: "Región 2: Andina Occidental",
            color: {
                bg: "#4AC1DD",
                text: "#fff",
            },
        },
        {
            id: "g2_region3",
            secondId: "gr2-region-3",
            name: "Región 3: Caribe Norte",
            color: {
                bg: "#13A8BA",
                text: "#fff",
            },
        },
        {
            id: "g2_region4",
            secondId: "gr2-region-4",
            name: "Región 4: Caribe Sur",
            color: {
                bg: "#23868E",
                text: "#fff",
            },
        },
        {
            id: "g2_region5",
            secondId: "gr2-region-5",
            name: "Región 5: Oriente",
            color: {
                bg: "#2288BC",
                text: "#fff",
            },
        },
        {
            id: "g2_region6",
            secondId: "gr2-region-6",
            name: "Región 6: Pacífico",
            color: {
                bg: "#126087",
                text: "#fff",
            },
        },
        {
            id: "g2_region7",
            secondId: "gr2-region-7",
            name: "Región 7: Sur",
            color: {
                bg: "#134863",
                text: "#fff",
            },
        },
    ]
}